import React, { useState, useEffect } from 'react';

import { SingleLink } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { ContractorAttendanceInfo_Bonus } from '../../../../item/ItemContractorAttendance';

export function ContractorAttendanceEditBonus({ contractorAttendance, bonus }) {
  const [mBonus, setBonus] = useState(new ContractorAttendanceInfo_Bonus({}))

  useEffect(() => {
    if (bonus !== undefined && mBonus !== bonus) {
      console.log(bonus)
      setBonus(bonus)
    }
  }, [bonus])

  function test(){

  }


  var title = <>出勤登錄計算-代招-上工人數&nbsp;<span className="text-success">{mBonus.Enrolment}</span>&nbsp;人</>
  var content =
    <>
      <div id="editable_wrapper" className="form-inline dt-bootstrap">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-striped table-bordered table-hover  dataTable">
              <thead>
                <tr role="row">
                  <th className="text-center sorting col-sm-2">項目名稱</th>
                  <th className="text-right sorting col-sm-2">合計金額</th>
                  <th className="text-center sorting col-sm-2">作業時間點</th>
                  <th className="text-center sorting col-sm-2">作業</th>
                  <th className="text-left sorting col-sm-2">提示</th>
                </tr>
              </thead>
              <tbody>
                <tr role="row">
                  <td className="text-center">代招金額</td>
                  <td className="text-center">{mBonus.Bonus.Amount}</td>
                  <td className="text-center">{mBonus.Bonus.ActionTime}</td>
                  <td className="text-center">
                    <SingleLink link={"ContractorAttendanceRegisterMonthly"}
                      name={"出勤登錄"}
                      Key={"Bonus"}
                      val={mBonus} >
                    </SingleLink>
                    </td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">營業稅</td>
                  <td className="text-center">{mBonus.Tax.Amount}</td>
                  <td className="text-center">{mBonus.Tax.ActionTime}</td>
                  <td className="text-center">--</td>
                  <td className="text-center">請注意</td>
                </tr>

                <tr role="row">
                  <td className="text-center">發票金額</td>
                  <td className="text-center">{mBonus.Invoice.Amount}</td>
                  <td className="text-center">{mBonus.Invoice.ActionTime}</td>
                  <td className="text-center">
                    <a href="#A" onClick={e => test()} >新增至請款作業</a>
                  </td>
                  <td className="text-center">請注意</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

